import Service from './Service';

export default class SupplierService extends Service {
    constructor() {
        super();
        this.baseURL = 'storemanagement/supplier/';
    }


}